import { ProgressCircle } from "antd-mobile"
import {
  NutrientChartWrapper,
  NutrientChartCalorieBox,
  NutrientChartCalorie,
  NutrientChartCalorieLabel,
} from "./styled"
import { PieChart, Pie, Cell } from "recharts"
import { getDisplayCalories } from "utils"

interface INutrientDetailsItem {
  name: string
  color: string
  value: number
  percent: string
  gram: number
}

const NutrientPieChart = ({
  nutrient,
  calorie,
}: {
  nutrient: INutrientDetailsItem[]
  calorie: number
}) => {
  const data =
    calorie === 0
      ? [{ name: "No Data", value: 100, color: "rgba(0, 38, 58, 0.14)" }]
      : nutrient
  return (
    <NutrientChartWrapper>
      {calorie === 0 ? (
        <ProgressCircle
          percent={0}
          style={{
            "--track-width": "4px",
            "--size": "60px",
            "--fill-color": "#fff",
            "--track-color": "#00263A24 ",
          }}
        ></ProgressCircle>
      ) : (
        <PieChart width={60} height={60}>
          {" "}
          <Pie
            startAngle={90}
            endAngle={-270}
            cx="50%"
            cy="50%"
            data={data}
            innerRadius={25}
            outerRadius={30}
            fill="#8884d8"
            paddingAngle={1}
            dataKey="value"
            cornerRadius={50}
          >
            {" "}
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      )}

      <NutrientChartCalorieBox>
        <NutrientChartCalorie>
          {getDisplayCalories(calorie)}
        </NutrientChartCalorie>
        <NutrientChartCalorieLabel>cal</NutrientChartCalorieLabel>
      </NutrientChartCalorieBox>
    </NutrientChartWrapper>
  )
}

export default NutrientPieChart
